var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailsignin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 37.5C6.46875 37.5 5.58594 37.1328 4.85156 36.3984C4.11719 35.6641 3.75 34.7812 3.75 33.75V11.25C3.75 10.2188 4.11719 9.33594 4.85156 8.60156C5.58594 7.86719 6.46875 7.5 7.5 7.5H37.5C38.5312 7.5 39.4141 7.86719 40.1484 8.60156C40.8828 9.33594 41.25 10.2188 41.25 11.25V33.75C41.25 34.7812 40.8828 35.6641 40.1484 36.3984C39.4141 37.1328 38.5312 37.5 37.5 37.5H7.5ZM22.5 24.375L7.5 15V33.75H37.5V15L22.5 24.375ZM22.5 20.625L37.5 11.25H7.5L22.5 20.625ZM7.5 15V11.25V33.75V15Z",
    fill: "#780000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailsignin);
export default __webpack_public_path__ + "static/media/mailsignin.1a1f190bc9dfd33b211302bec3a6e559.svg";
export { ForwardRef as ReactComponent };